import * as React from "react";
import ReactPDF, { Page, View, Text } from "@react-pdf/renderer";
import Report6PDFTemplateReportingPeriod from "./Report6PDFTemplateReportingPeriod";
import { TReport6ApplicantPresentationModel } from "../../../presenter/report/model/Report6ApplicantPresentationModel";
import { TReport6ReportingPeriodPresentationModel } from "../../../presenter/report/model/Report6ReportingPeriodPresentationModel";

const Report6PDFTemplateApplicant = ({
  translate,
  applicant,
  styles
}: {
  translate: any;
  applicant: TReport6ApplicantPresentationModel;
  styles: ReactPDF.Styles;
}) => {
  const renderReportingPeriods = () => {
    let reportingPeriods: JSX.Element[] = [];
    applicant.reportingPeriods?.forEach(
      (reportingPeriod: TReport6ReportingPeriodPresentationModel) => {
        reportingPeriods.push(
          <Report6PDFTemplateReportingPeriod
            key={`pdf-rp-${reportingPeriod.reportingPeriodId}`}
            translate={translate}
            reportingPeriod={reportingPeriod}
            styles={styles}
          />
        );
      }
    );
    return reportingPeriods;
  };

  return (
    <Page size="A4" style={styles.body} orientation={"landscape"}>
      <View style={styles.titleCol}>
        <Text style={styles.title}>{`${translate(
          "report6_preview_applicant.name_and_surname"
        )}: ${applicant.fullName}`}</Text>
      </View>
      {renderReportingPeriods()}
      <Text
        style={styles.pageNumbers}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        fixed
      />
    </Page>
  );
};

export default Report6PDFTemplateApplicant;
